import {
  AllCommunityModule,
  CellDoubleClickedEvent,
  CellValueChangedEvent,
  ColDef,
  DetailGridInfo,
  FirstDataRenderedEvent,
  GetRowIdParams,
  GridReadyEvent,
  ICellRendererParams,
  INumberCellEditorParams,
  IRichCellEditorParams,
  KeyCreatorParams,
  ValueFormatterParams,
  ValueParserParams,
} from "ag-grid-community";
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  AccountantAccount,
  DebtData,
  Permission,
  Program,
} from "../PaymentReceipt/InternalReceipt/InternalReceiptModel";
import {
  AgGridReact,
  CustomCellEditorProps,
  CustomCellRendererProps,
} from "ag-grid-react";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  baseTheme,
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { MRT_PaginationState } from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Select,
  SelectProps,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconCheck,
  IconCoinPound,
  IconDeviceFloppy,
  IconSearch,
  IconTicket,
  IconTimeDuration15,
  IconUser,
  IconWriting,
  IconX,
} from "@tabler/icons-react";
import { DateInput, DatePickerInput } from "@mantine/dates";
import { SelectListItem } from "../../../model/SelectListItem";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { orange } from "../../../const/variables";
import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import { modals } from "@mantine/modals";
import DebtObjectCodeFund from "../Bill/DebtObject/DebtObject";
import { useNavigate } from "react-router-dom";
import FormAccount from "../Bill/FormAccount/FormAccount";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  DateEditorModule,
  MasterDetailModule,
} from "ag-grid-enterprise";
// import creatorbranchEditor from "./creatorbranchEdit";
import { EmployeeModel } from "../../../model/Employee";
import {
  CreateReceiptParentRequest,
  DepartmentUser,
} from "../PaymentReceipt/model/modelPaymentReceipt";
import { notifications } from "@mantine/notifications";
import ListCustomer from "../Bill/ListCustomer/ListCustomer";
import ListSupplier from "../Bill/ListSupplier/ListSupplier";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import CustomerByBranch from "../Bill/CustomerByBranch/CustomerByBranch";
import ListEmployeebyBranch from "../Bill/ListEmployeebyBranch/ListEmployeebyBranch";
import ListEmployeebyBranch2 from "../Bill/ListEmployeebyBranch2/ListEmployeebyBranch2";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { useForm } from "@mantine/form";
import { addHours, set } from "date-fns";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  AllCommunityModule,
  DateEditorModule,
  MasterDetailModule,
]);

interface DataList {
  lists: any[];
  count: number;
}

interface AccountantAccounts {
  id: number;
  accountantAccount: string;
  accountantAccountName: string;
  accountLevel: number;
  createBy?: string | null;
  createDate?: Date | null;
  lastUpdateDate?: Date | null;
  lastUpdateBy?: string | null;
}
interface DepartmentInfo {
  active: boolean;
  address: string | null;
  attribute1: string | null;
  attribute2: string | null;
  attribute3: string | null;
  branchId: number;
  createdBy: string | null;
  creationDate: string | null;
  deparmentCode: string;
  departmentId: number;
  description: string | null;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
  name: string;
}
interface OrderHeaderModel {
  id: number;
  orderNumber: string;
  orderTypeId: number;
  orderDate: Date;
  orderStatus: string;
  note: string;
  orgId: number;
  invOrgId?: number;
  deptId?: number;
  divisionId?: number;
  saleChanelId?: number;
  sourceOrderNumber: string;
  sourceDocument: string;
  sourceInvoices: string;
  custId: number;
  custGroupId?: number;
  contactPersonId?: number;
  billToLocationId?: number;
  shipToLocationId?: number;
  invoiceSerial: string;
  invoiceNumber: string;
  invoiceDate?: Date;
  taxCode: string;
  taxAddr: string;
  amountTotal?: number;
  amountDiscount?: number;
  amountVoucher?: number;
  amountVat?: number;
  currentcyCode: string;
  currentcyRate?: number;
  amountPaid?: number;
  amountRemaining?: number;
  paymentType: string;
  paymentStatus: string;
  paymentMethod: string;
  paymentDue?: number;
  saleId: number;
  managerId?: number;
  approveId?: number;
  approveNote: string;
  rejectNote: string;
  shipngType: string;
  shipingVendor: string;
  shippingCode: string;
  shippingStatus: string;
  shippingPriority: string;
  shippingDate?: Date;
  shippingNote: string;
  technicalNote: string;
  attribute1?: string;
  attribute2?: string;
  attribute3?: string;
  attribute4?: string;
  attribute5?: string;
  attribute6?: string;
  attribute7?: string;
  attribute8?: string;
  attribute9?: string;
  attribute10?: string;
  attribute11?: string;
  attribute12?: string;
  attribute13?: string;
  attribute14?: string;
  attribute15?: string;
  clientId?: number;
  createBy?: number;
  createDate?: Date;
  lastUpdateBy?: number;
  lastUpdateDate?: Date;
  orderStatusId?: number;
  salesShift: string;
  printInvoiceCheck?: number;
  orderGuid: string;
  orderTypeCode: string;
  technicalRequired?: number;
  technicalCheck?: boolean;
  technicalEmp?: number;
  technicalSuccess?: boolean;
  contractcode: string;
  seqIndex?: number;
  orderNumberLink: string;
  discountAdded?: number;
  approveStatus?: number;
  discountAddedTotal?: number;
  typereturnid: string;
  approveDate?: Date;
  shippingFinishDate?: Date;
  dateofreceipt?: Date;
  attribute16?: string;
  attribute17?: string;
  attribute18?: string;
  attribute19?: string;
  attribute20?: string;
  islock?: boolean;
  ispayment?: boolean;
  attribute50?: string;
  attribute21?: string;
  attribute22?: string;
  attribute23?: string;
  attribute24?: string;
  attribute25?: string;
  attribute26?: string;
  attribute27?: string;
  attribute28?: string;
  attribute29?: string;
  attribute30?: string;
  attribute31?: string;
  attribute32?: string;
  attribute33?: string;
  attribute34?: string;
  attribute35?: string;
  attribute36?: string;
  attribute37?: string;
  attribute38?: string;
  attribute39?: string;
  attribute40?: string;
  rowversion?: Uint8Array;
  amountDiscountTotal?: number;
  depName?: string;
  saleName?: string;
  saleCode?: string;
  attribute18Name?: string;
  attribute18Code?: string;
  attribute16Name?: string;
  attribute16Code?: string;
  custName?: string;
  custCode?: string;
  attribute2Name?: string;
  attribute2Code?: string;
}
interface OrderModelSearch {
  invId?: number;
  invOutwardId?: number;
  customerId?: number;
  startDate?: Date | string; // ISO date string
  endDate?: Date | string; // ISO date string
  orderStatus?: string;
  orderCode?: string;
  orderNumber?: string;
  paymentStatus?: string;
  industry?: string;
  orderType?: number;
  outWardStatus?: string;
  technicalStatus?: string;
  shippingStatus?: string;
  createBy?: number;
  phone?: string;
  codeCustomer?: string;
  keySearch?: string;
}
export const AdjustmentSlipOrder = () => {
  const [height, setHeight] = useState(0);
  const sizeGrid = { base: 6, sm: 2, md: 2, lg: 2, xl: 2 };
  const [dataFetch, setDataFetch] = useState<DepartmentInfo[]>([]);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [data, setData] = useState<OrderHeaderModel[]>([]);
  const [dataWarehouse, setDataWarehouse] = useState<SelectListItemBase[]>([]);
  const gridRef = useRef<AgGridReact<OrderHeaderModel>>(null);
  const navigate = useNavigate();
  const [dataAcount, setDataAcount] = useState<AccountantAccount[]>([]);
  const editListRef = useRef(new Set<number>());

  const [dataDepartment, setDataDepartment] = useState<DepartmentInfo[]>([]);
  const [search, setSearch] = useState({
    keySearch: "",
    customerId: "",
    Start: "",
    End: "",
    codefund: "",
    accountfund: "",
    deartment: "",
    branch: "",
    type: "",
    workplace: "",
    creator: "",
    Type: 0,
    typeReceipt: "",
  });

  const form = useForm<OrderModelSearch>({
    initialValues: {},
  });

  const dataAccountFund = [
    { value: "1", label: "VND" },
    { value: "2", label: "USD" },
    { value: "3", label: "Vàng SJC 9999" },
    { value: "4", label: "Vàng PNJ 9999" },
  ];

  const optionColorsAccount: Record<
    "VND" | "USD" | "Vàng SJC 9999" | "Vàng PNJ 9999",
    string
  > = {
    VND: "cyan",
    USD: "green",
    "Vàng SJC 9999": "blue",
    "Vàng PNJ 9999": orange.medium,
  };

  const renderSelectOptionType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={option.value === "1" ? "blue" : "green"}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const headerRef = React.useRef<HTMLDivElement>(null);

  const containerStyle = useMemo(
    () => ({ width: "100%", height: height - 20, marginTop: "15px" }),
    [height]
  );
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const defaultColDef = useMemo<ColDef<OrderHeaderModel>>(() => {
    return {
      //  flex: 1,
      editable: true,
    };
  }, []);

  // Hàm gọi API phòng ban
  const fetchDataSelect = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<DepartmentInfo[]>>(
      "/api/v1/TblDepartment/get-all"
    );

    if (dataApi && dataApi.success) {
      setDataDepartment(dataApi.data);
    }
  };
  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  //Hàm get tài khoản nợ và có
  const fetchDataReceiptAcount = async () => {
    const response = await repositoryPos.get<
      MessageResponse<AccountantAccount[]>
      //2 là phiếu báo có và phiếu báo nợ
    >("/api/v1/TblDmAccount/get-list?Skip=0&Take=999");

    if (response && response.success) {
      let result = response.data;
      setDataAcount(result);
    }
  };

  const onCellValueChanged = useCallback(
    (params: CellValueChangedEvent<OrderHeaderModel>) => {
      const colId = params.data.id;
      editListRef.current.add(colId);
      // if (colId === "attribute5") {
      //   params.node.setDataValue("attribute5", params.value);
      // }
      // //Chọn người lập phiếu
      // if (colId === "creatorbranch") {
      //   const text = dataBranch.find(
      //     (color) => color.value.toString() === String(params.data.attribute10)
      //   );
      //   params.node.setDataValue("creatorworkplace", text?.att1 ?? "");
      // } else if (colId === "fundbranch") {
      //   //Phòng ban người nộp nhận tiền
      //   const text = dataBranch.find(
      //     (color) => color.value.toString() === String(params.data.attribute10)
      //   );
      //   params.node.setDataValue("fundworkplace", text?.att1 ?? "");
      //   // setData((prev) => {
      //   //   const updatedData = prev.map((item, i) => {
      //   //     if (i === rowIndex) {
      //   //       return {
      //   //         ...item,
      //   //         fundworkplace: text?.att1 ?? "",
      //   //       };
      //   //     }
      //   //     return item;
      //   //   });
      //   //   return updatedData;
      //   // });
      // }
    },
    []
  );
  const handleListEmployyee = (
    value: any,
    params?: CellDoubleClickedEvent<OrderHeaderModel>
  ) => {
    if (value) {
      console.log(value, "cjecl");
      if (params?.colDef.field === "attribute10")
        //Nhân viên
        params?.node.setDataValue("creatorfullname", String(value.id));
      params?.node.setDataValue(
        "creatorfullnameTemp",
        value.code + " - " + value.fullname
      );
      //Phòng ban
      params?.node.setDataValue(
        "creatordepartment",
        String(value.departmentId)
      );
      params?.node.setDataValue("creatordepartmentTemp", value.attribute10);
      //Bộ phận
      params?.node.setDataValue("createrolename", String(value.roleId));
      params?.node.setDataValue("createrolenameTemp", value.roleName);
    }
  };

  const fetchData = async () => {
    try {
      // Tạo queryParams, chỉ thêm các giá trị hợp lệ
      let _da = {
        ...form.getValues(),
      };
      if (_da.startDate && _da.startDate != null)
        _da.startDate = addHours(_da.startDate, 7).toISOString();
      else _da.startDate = "";
      if (_da.endDate) _da.endDate = addHours(_da.endDate, 7).toISOString();
      else _da.endDate = "";
      if (_da.createBy) _da.createBy = Number(_da.createBy);
      else _da.createBy = 0;
      // Chuyển queryParams thành chuỗi URL
      const url =
        "/api/v1/CreateSellItem/get-list-edit?" +
        new URLSearchParams(_da as Record<string, string>).toString();

      // Gọi API
      const response = await repositoryPos.get<
        MessageResponse<OrderHeaderModel[]>
      >(url);

      if (response && response.success) {
        setData(response.data);
        //  setRowCount(response.totalCount);
      }
    } catch (error) {
      console.error(error);
    }
  };
  //Chi nhánh của người lập phiếu
  const createSaleBrandEdit = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        onValueChange(newBranchValue);
        stopEditing();
      };

      return (
        <div ref={refContainer} tabIndex={1}>
          <Select
            searchable
            clearable
            placeholder="Chi nhánh"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataBranch.map((item) => ({
              label: item.text ?? "",
              value: String(item.value ?? ""),
            }))}
            value={value}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    }
  );

  const createDepCreateEdit = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps<OrderHeaderModel>) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        if (!newBranchValue) NotificationExtension.Fails("Chọn phòng ban !");
        else {
          onValueChange(Number.parseInt(newBranchValue ?? "0"));
        }
        stopEditing();
      };

      return (
        <div ref={refContainer} tabIndex={1}>
          <Select
            searchable
            clearable
            placeholder="Chi nhánh"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataDepartment
              .filter((x) => x.branchId === node.data?.orgId)
              .map((item) => ({
                label: "[" + item.deparmentCode + "] " + item.name,
                //    label: item.name,
                value: String(item.departmentId ?? ""),
              }))}
            defaultValue={value?.toString()}
            value={value?.toString()}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    }
  );

  const createEmpCreateEdit = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps<OrderHeaderModel>) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        if (!newBranchValue) NotificationExtension.Fails("Chọn nhân viên !");
        else {
          onValueChange(Number.parseInt(newBranchValue ?? "0"));
        }
        stopEditing();
      };

      return (
        <div ref={refContainer} tabIndex={1}>
          <Select
            searchable
            clearable
            placeholder="Nhân viên"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={listEmployee.map((item) => ({
              label: "[" + item.att1 + "] " + item.text,
              value: item.value,
            }))}
            defaultValue={value?.toString()}
            value={value?.toString()}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    }
  );
  const createAttr18Edit = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps<OrderHeaderModel>) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        if (!newBranchValue) NotificationExtension.Fails("Chọn nhân viên !");
        else {
          onValueChange(newBranchValue);
        }
        stopEditing();
      };

      return (
        <div ref={refContainer} tabIndex={1}>
          <Select
            searchable
            clearable
            placeholder="Nhân viên"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={listEmployee.map((item) => ({
              label: "[" + item.att1 + "] " + item.text,
              value: item.value,
            }))}
            defaultValue={value?.toString()}
            value={value?.toString()}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    }
  );
  const createSaleChannelEdit = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps<OrderHeaderModel>) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        if (!newBranchValue) NotificationExtension.Fails("Chọn kênh bán !");
        else {
          onValueChange(Number.parseInt(newBranchValue ?? "0"));
        }
        stopEditing();
      };

      return (
        <div ref={refContainer} tabIndex={2}>
          <Select
            searchable
            clearable
            placeholder="Kênh bán"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={saleChanelList.map((item) => ({
              label: "[" + item.code + "] " + item.name,
              //    label: item.name,
              value: String(item.id ?? ""),
            }))}
            defaultValue={value?.toString()}
            value={value?.toString()}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    }
  );
  const handleChooseDetailsCustomer = (
    value: any,
    isChooseCustomer: any,
    openFormCustomer: any,
    children?: boolean,
    RowIndex?: any
  ) => {};
  const handleChooseAccount = (
    value: AccountantAccounts,
    openFormAccount: any
  ) => {
    setData((prevDebtData: any) => {
      const updatedDebtData = prevDebtData.map((data: any, index: number) => {
        if (index === openFormAccount.rowIndex) {
          return {
            ...data,
            codefund: Number(value?.accountantAccount) ?? null,
            attribute6: value?.accountantAccountName ?? "",
          };
        }
        return data;
      });
      return updatedDebtData;
    });
  };
  function openFormDetailsCustomer(
    isChooseCongNo: boolean,
    openFormCustomer?: CellDoubleClickedEvent<any>,
    children?: boolean,
    RowIndex?: any
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách đối tượng công nợ</Title>
        </>
      ),
      size: "90vw",
      children: (
        <DebtObjectCodeFund
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseDetailsCustomer}
          navigate={navigate}
          disible
          children={children}
          RowIndex={RowIndex}
          paramDetailsEditDonHang={openFormCustomer}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  useEffect(() => {
    fetchDataBranch();
    fetchDataSelect();
    fetchDataEmployee();
    fetchDataReceiptAcount();
    fetchDataSaleChanelId();
    // fetchDataReceiptContract();
  }, []);

  const [listEmployee, setListEmployee] = useState<SelectListItemBase[]>([]);

  const fetchDataEmployee = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >(`/api/v1/TblDmEmployee/get-select`);

    if (response?.success) {
      setListEmployee(response.data);
    }
  };

  //KH

  const handleListCustomerOrder = (
    value: any,
    params?: CellDoubleClickedEvent<OrderHeaderModel>
  ) => {
    if (value) {
      params?.node.setDataValue("custId", value.id);
      params?.node.setDataValue("custName", value.name);
      params?.node.setDataValue("custCode", value.code);
    }
  };
  function openListCustomer(params?: any) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách khách hàng</Title>
        </>
      ),
      size: "90vw",
      children: (
        <ListCustomer
          params={params}
          handleListCustomer={handleListCustomerOrder}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const [saleChanelList, setSaleChanelList] = useState<any[]>([]);
  const fetchDataSaleChanelId = async () => {
    const response = await repositoryMdm.get<MessageResponse<any[]>>(
      "/api/v1/TblDmSaleChanel/get-all"
    );

    if (response && response.success) {
      let result = response.data;
      setSaleChanelList(result);
    }
  };

  //danh sách theo từng hàng
  const columnDefs = useMemo<ColDef<OrderHeaderModel>[]>(
    () => [
      {
        field: "orderNumber",
        headerName: "Mã phiếu",
        filter: "agTextColumnFilter",
        pinned: "left",
        maxWidth: 200,
        editable: false,
      },
      {
        field: "orderDate",
        headerName: "Thời gian hoàn thành",
        valueFormatter: (
          params: ValueFormatterParams<OrderHeaderModel, Date>
        ) => {
          if (!params.value) {
            return "";
          }

          const date = new Date(params.value);
          if (isNaN(date.getTime())) {
            return "Sai định dạng ngày !";
          }

          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const seconds = date.getSeconds();

          return `${year}-${month < 10 ? "0" + month : month}-${
            day < 10 ? "0" + day : day
          } ${hours < 10 ? "0" + hours : hours}:${
            minutes < 10 ? "0" + minutes : minutes
          }:${seconds < 10 ? "0" + seconds : seconds}`;
        },
        cellEditor: "agTextCellEditor",
        minWidth: 200,
      },
      {
        field: "deptId",
        headerName: "Bộ phận người lập phiếu",
        filter: "agNumberColumnFilter",
        minWidth: 300,
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          return (
            <>
              {
                dataDepartment.find(
                  (x) => x.departmentId === params.data?.deptId
                )?.name
              }
            </>
          );
        },
        cellEditor: createDepCreateEdit,
        cellEditorPopup: true,
      },
      {
        field: "saleId",
        headerName: "Nhân viên bán hàng",
        filter: "agTextColumnFilter",
        minWidth: 230,
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          const emp = listEmployee.find(
            (x) => x.value === params.data?.saleId?.toString()
          );
          return <>{"[" + emp?.att1 + "] " + emp?.text}</>;
        },
        cellEditor: createEmpCreateEdit,
        cellEditorPopup: true,
      },
      {
        field: "attribute18",
        headerName: "Người hưởng số",
        filter: "agTextColumnFilter",
        minWidth: 250,
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          const emp = listEmployee.find(
            (x) => x.value === params.data?.attribute18
          );
          return <>{"[" + emp?.att1 + "] " + emp?.text}</>;
        },
        cellEditor: createAttr18Edit,
        cellEditorPopup: true,
      },
      {
        field: "attribute16",
        headerName: "Đối tượng công nợ",
        filter: "agTextColumnFilter",
        minWidth: 300,
        editable: false,
        cellEditorPopup: true,
        onCellDoubleClicked: (params: CellDoubleClickedEvent<any>) => {
          openFormDetailsCustomer(true, params);
        },
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          return (
            <>
              {"[" +
                params.data?.attribute16 +
                "] " +
                params.data?.attribute16Name}
            </>
          );
        },
      },
      {
        field: "custId",
        headerName: "Khách hàng",
        filter: "agTextColumnFilter",
        editable: false,
        minWidth: 300,
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          return (
            <>{"[" + params.data?.custCode + "] " + params.data?.custName}</>
          );
        },
        onCellDoubleClicked: (
          params: CellDoubleClickedEvent<OrderHeaderModel>
        ) => {
          openListCustomer(params);
        },
      },
      {
        field: "attribute2",
        headerName: "Thu ngân",
        minWidth: 300,
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          const emp = listEmployee.find(
            (x) => x.value === params.data?.attribute2
          );
          return <>{"[" + emp?.att1 + "] " + emp?.text}</>;
        },
        cellEditor: createAttr18Edit,
        cellEditorPopup: true,
      },
      {
        field: "saleChanelId",
        headerName: "Kênh bán hàng",
        minWidth: 300,
        cellRenderer: (params: CustomCellRendererProps<OrderHeaderModel>) => {
          const getChannel = saleChanelList.find(
            (x) => x.id === params.data?.saleChanelId
          );
          return <>{getChannel.name}</>;
        },
        cellEditor: createSaleChannelEdit,
      },
      {
        field: "attribute16Name",
        hide: true,
        editable: false,
      },
      {
        field: "custCode",
        hide: true,
        editable: false,
      },
      {
        field: "custName",
        hide: true,
        editable: false,
      },
    ],
    [data]
  );

  const handleComplete = async () => {
    try {
      const response = await repositoryPos.post<
        MessageResponse<CreateReceiptParentRequest>
      >("api/v1/CreateSellItem/update-order-header-list", {
        orderHeaders: data.filter((item) => editListRef.current.has(item.id)),
      });

      if (response && response.httpStatusCode === 200 && response?.success) {
        if (response.success) {
          await fetchData();
          editListRef.current.clear();
          NotificationExtension.Success("Điều chỉnh phiếu thành công !");
        } else {
          NotificationExtension.Fails("Điều chỉnh phiếu thất !");
        }
      }
    } catch (error) {
      console.error(error);
      NotificationExtension.Fails("Có lỗi xảy ra khi điều chỉnh phiếu thất !");
    }
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (200 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  return (
    <div style={containerStyle}>
      <Group justify="space-between">
        <_breadcrumb></_breadcrumb>
        <Flex gap={10}>
          {/* <Button
            leftSection={<IconCheck size={14} />}
            color="green"
            bd="1px solid green"
            variant="violet"
            onClick={() => console.log(data)}
          >
            chekc
          </Button> */}
          <Button
            leftSection={<IconDeviceFloppy size={14} />}
            color="blue"
            bd="1px solid blue"
            variant="light"
            onClick={() => handleComplete()}
          >
            Lưu thay đổi
          </Button>
        </Flex>
      </Group>
      <Grid mt={5} mb={5}>
        <Grid.Col span={{ base: 6, sm: 6, md: 6, lg: 4 }}>
          <Input
            key={form.key("keySearch")}
            placeholder="Từ khóa (tìm nhiều đơn VD: DH1,DH2,DH3)"
            type="text"
            leftSection={<IconSearch color="#15aabf" />}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await fetchData();
              }
            }}
            {...form.getInputProps("keySearch")}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            key={form.key("startDate")}
            type="default"
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Từ ngày"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            {...form.getInputProps("startDate")}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            key={form.key("endDate")}
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Đến ngày"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            {...form.getInputProps("endDate")}
          />
        </Grid.Col>
        {/* <Grid.Col span={sizeGrid}>
          <Select
            key={form.key("branch")}
            searchable
            clearable
            placeholder="Chi nhánh"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataBranch.map((item) => {
              return {
                label: item.text ?? "",
                value: String(item.value ?? ""),
              };
            })}
            {...form.getInputProps("branch")}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            key={form.key("deartment")}
            searchable
            clearable
            placeholder="Phòng ban"
            limit={50}
            leftSection={<IconBuildingSkyscraper color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={dataFetch
              .filter((item) => item.name !== "Tất cả")
              .map((item) => {
                return {
                  label: "[" + item.deparmentCode + "] " + item.name ?? "",
                  value: String(item.departmentId ?? ""),
                };
              })}
            {...form.getInputProps("")}
          />
        </Grid.Col> */}

        <Grid.Col span={sizeGrid}>
          <Select
            key={form.key("createBy")}
            searchable
            clearable
            placeholder="Người tạo"
            leftSection={<IconUser color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            data={listEmployee.map((item) => {
              return {
                label: item.text ?? "",
                value: String(item.value ?? ""),
              };
            })}
            {...form.getInputProps("createBy")}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>

      <div
        style={{ height: "100%", boxSizing: "border-box", paddingTop: "10px" }}
      >
        <AgGridReact<OrderHeaderModel>
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onCellValueChanged={onCellValueChanged}
          rowData={data}
          theme={baseTheme}
          suppressColumnVirtualisation={true}
          suppressRowVirtualisation={true}
          pagination={true}
          localeText={AG_GRID_LOCALE_VN}
          autoSizeStrategy={{
            type: "fitCellContents",
          }}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
        />
      </div>
    </div>
  );
};
